<div class="robot-rules-container price">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.condition" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_event" | translate }}</span>
        <div class="v4-layout-field-control" [formGroup]="actionForm">
          <div class="v4-layout-field-row">
            <span class="node-type mr-md">{{ "robot.rule.condition.evt.everyday" | translate }}</span>
            <!-- <host-cascaded-time-picker-v2
              formControlName="node_minute"
              [listOfOptions]="listOfTimeOption"></host-cascaded-time-picker-v2> -->
            <nz-select
              nzSize="large"
              formControlName="node_minute"
              [nzOptions]="listOfTimeOption"
              [nzCustomTemplate]="formatTimeTpl"></nz-select>
            <ng-template #formatTimeTpl let-selected>
              <!-- 之所以加一个日期前缀，是因为 dateformat 接受的是一个有效的日期格式，仅有时间不是一个有效的格式，所以这里利用一个随机日期将其拼接完整 -->
              {{ selected.nzLabel }}
              <!-- {{ normalizeTimeString(selected.nzLabel) }} -->
            </ng-template>
          </div>
        </div>
      </div>
      <ng-container [formGroup]="scopeForm">
        <div class="v4-layout-field">
          <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel" | translate }}</span>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <nz-select
                class="w-full placeholder-dark"
                nzSize="large"
                nzMode="multiple"
                formControlName="thirdparty"
                [nzPlaceHolder]="'word.all' | translate"
                [nzOptions]="listOfChannelOption"></nz-select>
              <!-- <host-simple-multi-select
                class="w-full"
                formControlName="thirdparty"
                placeholderKey="word.select_option.placeholder.channel"
                [listOfOption]="listOfChannelOption"
                [borderless]="false"
              ></host-simple-multi-select> -->
            </div>
          </div>
        </div>
        <div class="v4-layout-field">
          <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel_account" | translate }}</span>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <nz-select
                class="w-full placeholder-dark"
                nzSize="large"
                nzMode="multiple"
                formControlName="account"
                [nzPlaceHolder]="'word.all' | translate"
                [nzOptions]="listOfAccountOption"></nz-select>
              <!-- <host-simple-multi-select
                class="w-full"
                formControlName="account"
                [listOfOption]="listOfAccountOption"
                [borderless]="false"
              ></host-simple-multi-select> -->
            </div>
          </div>
        </div>
        <widget-rule-form-item-house-picker
          [data]="$any(scopeHouses)"
          (onChange)="scopeHouses = $event"></widget-rule-form-item-house-picker>
      </ng-container>
    </div>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      <!-- 开始任务 -->
      {{ "robot.rule.price_action_title" | translate }}
      <!-- {{ "robot.task.title.action1" | translate }} -->
    </div>
    <div class="block-list">
      <div class="v4-layout-field" [formGroup]="actionForm">
        <span class="v4-layout-field-label">{{ "robot.rule.price_action_label" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row w-1/3">
            <nz-input-group nzSuffix="%" nzSize="large">
              <input formControlName="to_percent" type="number" nz-input />
            </nz-input-group>
          </div>
          <div class="v4-layout-field-extra">
            <span class="desc">
              {{
                "robot.rule.price_action_desc"
                  | translate
                    : {
                        number: (percent | number: "1.0-2")
                      }
              }}
              <!-- 如当前价格为100，则自动调价后将被改为{{ percent }}。已售房间不会被调价 -->
              <!-- {{ "如当前价格为100，则自动调价后将被改为90。已售房间不会被调价" | translate }} -->
              <!-- 任务的具体时间将在相关订单变为退房时自动设置 -->
              <!-- {{ "robot.rule.action.task_type1" | translate }} -->
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="left"></div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
